import * as Yup from 'yup';
import PhoneNumber from 'awesome-phonenumber';
import { Individual } from 'store/individuals/individual';
import { getNumberValidation } from 'views/declarations/utils/validation-utils';

type Params = {
    registeredUsers: Individual[] | undefined;
    editingUser?: Individual;
    withTeamId?: boolean;
};

export const getIndividualSchema = ({ registeredUsers, editingUser, withTeamId }: Params) => {
    return Yup.object().shape({
        fullName: Yup.string().required('Full name is required.'),
        email: Yup.string()
            .email('Email is invalid.')
            .required('Email is required.')
            .test('email-used', 'This email already exists.', (val: any) => {
                if (editingUser && val === editingUser.email) {
                    return true;
                }
                return val ? !registeredUsers?.some((user: Individual) => user.email === val) : true;
            }),
        type: Yup.string().nullable().required('Role is required.'),
        // Country code is required when we have a phone number
        phoneCountryCode: Yup.string()
            .nullable()
            .test('phoneCountryCode-required', 'Phone country code is required', function (value) {
                const { phoneNumber } = this.parent as {
                    phoneNumber?: number | null;
                };

                if (phoneNumber != null) {
                    return !!value;
                }

                return true;
            }),

        // Phone number is required when we provide a country code
        phoneNumber: getNumberValidation()
            .nullable()
            .test('phoneNumber-valid', 'Phone number is required', function (value?: number | null) {
                const { phoneCountryCode } = this.parent as {
                    phoneCountryCode?: string | null;
                };

                if (!phoneCountryCode && value == null) return true;
                if (!phoneCountryCode) return true;
                if (value == null) return true;

                // Validate real number
                const phoneNumber = new PhoneNumber(`${phoneCountryCode}${value}`);
                if (!phoneNumber.isValid()) {
                    return this.createError({
                        message: 'Phone number is invalid',
                    });
                }

                return true;
            }),

        address: Yup.object().shape({
            postCode: Yup.string().nullable().required('Post Code is required'),
            country: Yup.string().nullable().required('Country is required'),
            city: Yup.string().nullable().required('City is required'),
            addressLine1: Yup.string().nullable().required('Address Line 1 is required'),
        }),
        teamId: withTeamId ? Yup.string().required('Team Id is required') : Yup.string().nullable(),
    });
};
